import { useStore } from 'effector-react'

import {
  $budgetItemList,
  $totalBudgetItemList,
  budgetItemListMounted,
  getBudgetItemList,
} from './model'
import { BudgetItemListRequest } from './types'

export const useBudgetItemList = () => {
  const onChangeBudgetItemList = ({
    limit,
    page,
    orderBy,
    orderDirection,
  }: BudgetItemListRequest) => {
    budgetItemListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
    })
  }
  const loading = useStore(getBudgetItemList.pending)

  const budgetItemList = useStore($budgetItemList)
  const totalBudgetItemList = useStore($totalBudgetItemList)

  return {
    budgetItemList,
    totalBudgetItemList,
    loading,
    onChangeBudgetItemList,
  }
}
